/**
 * @fileoverview GET handler for the "/app_groups/:app_group_id/banner_priority" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdBannerPriority } from "./constants";
import type { GetAppGroupsAppGroupIdBannerPriorityResult } from "./types";
import { isGetAppGroupsAppGroupIdBannerPriorityResult } from "./validators";

export const getAppGroupsAppGroupIdBannerPriority = reactQueryFetcherAdapter(
  appGroupsAppGroupIdBannerPriority,
  (
    signal: AbortSignal,
    appGroupId: string,
    placementId: string
  ): Promise<GetAppGroupsAppGroupIdBannerPriorityResult> => {
    return fetch(`/app_groups/${appGroupId}/banner_priority`, "GET", { placement_id: placementId }, { signal });
  },
  isGetAppGroupsAppGroupIdBannerPriorityResult
);
